import { getCallingCodeForCountry } from "./phone-input-validator";
import { getI18nCountries } from "../../utils/getI18nCountries";

export interface CountryData {
    country: string;
    label: string;
    prefix: string;
}

let defaultLang: string | null = null;

export function getDefaultLanguage(): string {
    if (defaultLang === null) {
        try {
            defaultLang = document.getElementsByTagName("html")[0].getAttribute("lang").replace(/[-_]/g, "-").split("-")[0];
        } catch (e) {
            defaultLang = "en";
        }
    }
    return defaultLang;
}

/** List of countryCodes that should be displayed with the alias name instead of the official name */
const preferAliasCountries: string[] = ["TW"];

export async function getCountryDataProvider(lang: string): Promise<CountryData[]> {
    if (lang === undefined || lang.length === 0) {
        lang = getDefaultLanguage();
    }
    const { countries } = await getI18nCountries(lang);

    return Object.keys(countries)
        .map((countryCode) => {
            const label: string = Array.isArray(countries[countryCode])
                ? (preferAliasCountries.includes(countryCode) && countries[countryCode][1]) || countries[countryCode][0]
                : countries[countryCode].toString();
            return {
                country: countryCode,
                label: label,
                prefix: getCallingCodeForCountry(countryCode)
            };
        })
        .filter(({ prefix }) => prefix !== "")
        .sort(sortCountries);
}

const sortCountries = (a: CountryData, b: CountryData): number => {
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
};
